import { render } from "./SourcesTab.vue?vue&type=template&id=94ba4198&scoped=true"
import script from "./SourcesTab.vue?vue&type=script&lang=js"
export * from "./SourcesTab.vue?vue&type=script&lang=js"

import "./SourcesTab.vue?vue&type=style&index=0&id=94ba4198&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94ba4198"]])

export default __exports__